import { whatsappUrl } from "@/lib/api";

export const WhatsAppButton = ({ ride, testid }) => (
  <a
    href={whatsappUrl(ride)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="ff-btn-whatsapp w-full text-sm uppercase"
  >
    📲 PASSA AL COLLEGA VIA WHATSAPP
  </a>
);
